import { css } from '@emotion/css'
import { spacing, fontWeight, fontSize, shorthandHelper, colors } from '@offerzen/pinata'

const styles = {
  image: css({
    marginBottom: spacing.small,
  }),

  header: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: shorthandHelper([spacing.large, spacing.large, 0, spacing.large]),
    fontWeight: fontWeight.bold,
    marginBottom: 0,
  }),

  paragraph: css({
    fontSize: fontSize.default,
    textAlign: 'center',
    color: colors.scorpion,
  }),

  wrapper: css({
    textAlign: 'center',
    padding: shorthandHelper([spacing.default, spacing.large, spacing.large, spacing.large]),
  }),
}

export default styles
